const question5 = {
    'question': 'Co jest ważne i o czym mówić na pierwszej konsultacji psychologicznej?',
    'answer': 'Na pierwszej wizycie u psychologa ważne jest, aby być szczerym i otwartym. Psycholog potrzebuje jak największej ilości informacji, aby pomóc ci rozwiązać twoje problemy. Warto przedstawić swoje oczekiwania, nakreślić istotę problemu, a także powiedzieć o  niepokojących Cię objawach. Możesz również zadać psychologowi pytania, które Cię nurtują.',
}

export default question5;